export default {"src":"/_next/static/media/circus.46c8ef48.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};